import React, { Component } from 'react'
import SectionHeader from '../section-header'
import TimescaleSelector from '../timescale-selector'
import TreatmentActivity from '../treatment-activity'
import { Loading } from '../../../../../../components'
import Grid from '@material-ui/core/Grid'
import SectionModal from '../section-modal'
import moment from 'moment'
import { Box, Stack, Text, Link } from '@chakra-ui/react'
//import styles from './worksheets-section.module.css'
import BlurSection from '../blur-section'
import { withStyles } from '@material-ui/core'
import { endpoints } from '../../../../../../api'
//import theme from '../../../../theme'

const styles = theme => ({
  section: {
    flex: '0 0 32%',
    boxSizing: 'border-box',
    paddingRight: '30px',
    paddingBottom: '48px',
    paddingTop: '16px'
  },
  emptyText: {
    fontSize: '13px',
    marginTop: '48px',
    padding: '0 16px',
    lineHeight: 1.25,
    color: theme.palette.text.contrastOnWhite
  }
})

class TreatmentActivitiesSection extends Component {
  state = {
    loading: true,
    allTreatmentActivityData: null,
    filteredData: [],
    isModalOpen: false
  }

  componentDidMount = () => {
    if (this.props.patient.hasApp) {
      this.setState({ loading: true })
      this.fetchData()
    }
  }

  handleTimeScaleChange = timescale => {
    const filteredData = this.filterData(timescale)
    this.setState({ filteredData })
  }

  fetchData = () => {
    const day_start = moment(this.props.patient.created_at).format()
    const day_end = moment().format()
    const { user_id } = this.props

    return endpoints.getCheckInScoresForUser
      .request({
        id: user_id,
        module_type: 'treatment_activity',
        start_date: day_start,
        end_date: day_end
      })
      .then(json => {
        this.setState({
          allTreatmentActivityData: json,
          filteredData: json,
          loading: false
        })
      })
  }

  filterData = timescale => {
    const { allTreatmentActivityData } = this.state

    if (!allTreatmentActivityData) return []

    const date =
      timescale.value < 0
        ? moment(this.props.patient.created_at)
        : moment().subtract(timescale.value, timescale.unit)

    return this.filterByDate(date)
  }

  filterByDate = date => {
    // only return activities that have scores after the chosen date
    return this.state.allTreatmentActivityData.reduce(
      (filteredData, activity) => {
        const scores = activity.scores.filter(score =>
          moment(score.created_at).isSameOrAfter(date)
        )
        if (scores.length) {
          return filteredData.concat({
            ...activity,
            scores
          })
        }

        return filteredData
      },
      []
    )
  }

  handleModal = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
      if (this.state.isModalOpen) {
        window.analytics.track('View All Modal Opened - treatment', {
          platform: 'clinician_app'
        })
      }
    })
  }

  renderSection = () => {
    const { classes } = this.props
    const { filteredData } = this.state

    if (filteredData.length === 0) {
      return (
        <p className={classes.emptyText}>
          Client has not completed any worksheets during the selected time
          interval.
        </p>
      )
    }
    return (
      <Grid container spacing={1}>
        {filteredData.map(activity => {
          return (
            <Grid key={activity.module_id} item xs={12}>
              <Stack flex="1">
                <Stack
                  justify={{
                    base: 'start',
                    md: 'start'
                  }}
                  direction={{
                    base: 'row',
                    md: 'row'
                  }}
                >
                  <Box w={{ base: '8%', md: '15%' }}>
                    <Text textStyle="lg" color={'#2D54E8'} fontWeight="bold">
                      {activity.scores.length}
                    </Text>
                  </Box>
                  <Box w={{ base: '92%', md: '85%' }}>
                    <Text fontSize={'16px'} fontWeight={'430'}>
                      {activity.title}
                    </Text>
                  </Box>
                </Stack>
              </Stack>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  render() {
    const { classes } = this.props
    return (
      <div
        id="worksheets-section"
        className={`${classes.section} summary-section`}
        style={{
          borderRadius: '8px',
          border: '1px solid #E4E5E6',
          padding: '24px 32px 24px 32px',
          maxHeight: '392px',
          height: '392px',
          overflow: 'auto'
        }}
      >
        <Stack mb={'16px'} flex="1">
          <Stack
            justify={{
              base: 'start',
              md: 'space-between'
            }}
            direction={{
              base: 'row',
              md: 'row'
            }}
          >
            <Box w={{ base: '80%', md: '60%' }}>
              <Text textStyle="lg" fontWeight="bold">
                Worksheets
              </Text>
            </Box>
            <Box w={{ base: '20%', md: '40%' }}>
              {this.props.patient.hasApp && (
                <Link
                  textAlign={'end'}
                  onClick={() => this.handleModal()}
                  color={'#2D54E8'}
                >
                  <Text fontSize={'16px'} fontWeight={'430'}>
                    View all
                  </Text>
                </Link>
              )}
            </Box>
          </Stack>
          <Stack
            direction={{
              base: 'row',
              md: 'row'
            }}
          >
            <Box w={'100%'}>
              <Text fontSize={'16px'} fontWeight={'430'}>
                Generated from check-ins.
              </Text>
            </Box>
          </Stack>
        </Stack>
        {this.props.patient.hasApp ? (
          <>
            <TimescaleSelector
              handleTimeScaleChange={this.handleTimeScaleChange}
            />
            {this.state.loading ? <Loading /> : this.renderSection()}
            {this.state.isModalOpen && (
              <SectionModal
                isModalOpen={this.state.isModalOpen}
                treatmentData={this.state.allTreatmentActivityData}
                content="treatment"
                handleModal={this.handleModal}
                user_id={this.props.user_id}
                user_role={this.props.user_role}
                api={this.props.api}
                auth={this.props.auth}
              />
            )}
          </>
        ) : (
          <BlurSection
            sectionName="worksheets"
            action={this.props.sendInvite}
            patient={this.props.patient}
          />
        )}
      </div>
    )
  }
}

export default withStyles(styles)(TreatmentActivitiesSection)
